module.exports = __webpack_public_path__ + "media/images/front/robles_concept-9ca0c3fc66e45db0180698858a9e39a0.jpg";